"use client";

import {
  AlbumItem,
  AlbumItemSkeleton,
  InfinityScrollWrapper,
} from "@/components/partials";
import { VALIDATE_K } from "@/lib/constants";
import { AlbumItemType, PaginatedResType } from "@/lib/schema";

export default function AlbumList({
  initialData,
  limit = 6,
}: {
  initialData: PaginatedResType<AlbumItemType[]>;
  limit?: number;
}) {
  return (
    <InfinityScrollWrapper<AlbumItemType>
      initialData={initialData}
      limit={limit}
      fetchOptions={{
        next: { tags: [VALIDATE_K.albums] },
      }}
      endpoint="/album"
      className="grid grid-cols-6 max-md:grid-cols-3 max-sm:grid-cols-2 max-sm:gap-4 gap-7"
      renderItem={(album) => {
        return (
          <AlbumItem
            src={album.banner}
            name={album.title}
            count={album.totalLectures}
            href={`/albums/${album.id}`}
          />
        );
      }}
      renderSkeletonItem={() => <AlbumItemSkeleton />}
    />
  );
}
